import template from './_form.pug'

export default Vue.extend({
  template: template(),
  props: {
    initialData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSaving: false,
      errors: {
        typology: null,
        typologyMapping: null
      },
      form: {
        typology: '',
        level1: null,
        level2: null,
        isContact: null,
        isSale: null,
        isEffectiveContact: null,
        isClosed: null,
        usage: '',
        status: null,
        isNonManageableNonContacted: null,
        isNonManageableContacted: null,
        isManageableNonContacted: null,
        isManageableContacted: null,
        typologyMapping: ''
      }
    }
  },
  computed: {
    level1Options() {
      return [
        { value: 'CNU', label: this.t('options.level1.cnu') },
        { value: 'CU+', label: this.t('options.level1.cuPlus') },
        { value: 'CU-', label: this.t('options.level1.cuMinus') },
        { value: 'SIN TIPIFICAR', label: this.t('options.level1.untyped') }
      ];
    },
    level2Options() {
      return [
        { value: 'GESTIONABLES', label: this.t('options.level2.manageable') },
        { value: 'NO GESTIONABLES', label: this.t('options.level2.nonManageable') },
        { value: 'SIN TIPIFICAR', label: this.t('options.level2.untyped') }
      ];
    },
    statusOptions() {
      return [
        { value: 'CONTACTADO', label: this.t('options.status.contacted') },
        { value: 'NO CONTACTADO', label: this.t('options.status.nonContacted') }
      ];
    },
    yesNoOptions() {
      return [
        { value: 1, label: this.t('options.yesNo.yes') },
        { value: 0, label: this.t('options.yesNo.no') }
      ];
    }
  },
  watch: {
    initialData: {
      handler(newData) {
        if (newData && Object.keys(newData).length) {
          const cleanData = newData.data || newData;
          
          const numericFields = [
            'isContact', 'isSale', 'isEffectiveContact', 'isClosed', 
            'isNonManageableNonContacted', 'isNonManageableContacted', 
            'isManageableNonContacted', 'isManageableContacted'
          ];

          Object.keys(this.form).forEach(key => {
            if (cleanData[key] !== undefined && cleanData[key] !== null) {
              if (numericFields.includes(key)) {
                const parsed = parseInt(cleanData[key], 10);
                this.form[key] = isNaN(parsed) ? null : parsed;
              } else {
                this.form[key] = cleanData[key];
              }
            }
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    t(key) {
      return this.$t(`callStatusMappings.form.${key}`);
    },
    cancel() {
      this.$router.push({ name: 'call-status-mappings-index' });
    },
    validate() {
      let isValid = true;
      this.errors = { typology: null, typologyMapping: null };
      
      if (!this.form.typology || this.form.typology.toString().trim() === '') {
        this.errors.typology = this.t('errors.required');
        isValid = false;
      }
      if (!this.form.typologyMapping || this.form.typologyMapping.toString().trim() === '') {
        this.errors.typologyMapping = this.t('errors.required');
        isValid = false;
      }
      return isValid;
    },
    submit() {
      if (!this.validate()) return;
      
      this.isSaving = true;

      const payload = { ...this.form };
      const recordId = this.$route.params.id || this.initialData.id || (this.initialData.data && this.initialData.data.id);

      const apiCall = this.isEdit 
        ? API.callStatusMappings.update(recordId, payload) 
        : API.callStatusMappings.create(payload);

      apiCall.then(() => {
        this.$notifications.success(this.isEdit ? this.t('success.updated') : this.t('success.created'));
        this.$router.push({ name: 'call-status-mappings-index' });
      }).catch(error => {
        console.error(error);
        this.$notifications.error(this.t('errors.saveError'));
      }).finally(() => {
        this.isSaving = false;
      });
    }
  }
})